import * as core from '../../../../../../../core'

import { query } from './outcomes-table.query'

export const RESOURCE = {
  payload: {
    alias: 'summit:outcomes-table',
    content: {
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
      segments: [
        {
          alias: 'overview',
          name: 'Overview',
          root: {
            elements: [
              {
                content: {
                  row: {
                    elements: [
                      {
                        content: {
                          widget: {
                            widget: {
                              alias: 'summit.outcome-overview',
                            },
                          },
                        },
                        span: 12,
                      },
                    ],
                  },
                },
                height: 300,
              },
            ],
          },
        },
        {
          alias: 'outcomes',
          name: 'Outcomes',
          /* eslint-disable sort-keys */
          query: {
            selection: {
              if: [
                [
                  { '=': [{ '@$': 'currentEntityId' }, null] },
                  {
                    '{}': {
                      name: {
                        '@_': [['dim::!outcomes', 'root'], 'name'],
                      },
                    },
                  },
                ],
                { '@': 'childInfo' },
              ],
            },
            subqueries: {
              childInfo: {
                target: 'dim::!outcomes',
                quantity: 1,
                filter: {
                  and: [
                    {
                      '=': [{ '@_': 'id' }, { '@$': 'currentEntityId' }],
                    },
                    {
                      '=': [{ '@.': '!id' }, { '@$': 'currentRecordId' }],
                    },
                  ],
                },
                selection: {
                  '{}': {
                    isHidden: {
                      '@_': 'isLeaf',
                    },
                    name: {
                      '@_': ['child', 'name'],
                    },
                  },
                },
              },
            },
          },
          /* eslint-enable sort-keys */
          root: {
            elements: [
              {
                content: {
                  row: {
                    elements: [
                      {
                        content: {
                          widget: {
                            widget: {
                              alias: 'summit.outcomes-table',
                            },
                          },
                        },
                        span: 12,
                      },
                    ],
                  },
                },
                height: 500,
              },
            ],
          },
        },
      ],
    },
    description: 'Summit Outcomes Page (Table)',
    name: 'summit.outcomes.nested',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
